import { PwaInstallSheet } from "@frontend/components/pwa/PwaInstallSheet";
import { usePwaInstall } from "@frontend/hooks/usePwaInstall";
import { createContext, type ReactNode, useContext } from "react";

/**
 * Shares the install state across the tree: the bottom sheet (mounted once,
 * below), the notification banner and Profile → Notifications all read the
 * same install-available / standalone / iOS state and call install().
 */

type PwaInstallCtx = ReturnType<typeof usePwaInstall>;
const Ctx = createContext<PwaInstallCtx | null>(null);

export const PwaInstallHost = ({ children }: { children: ReactNode }) => {
	const state = usePwaInstall();
	return (
		<Ctx.Provider value={state}>
			{children}
			<PwaInstallSheet />
		</Ctx.Provider>
	);
};

export const usePwaInstallCtx = () => {
	const ctx = useContext(Ctx);
	if (!ctx) {
		throw new Error("usePwaInstallCtx must be used inside <PwaInstallHost>");
	}
	return ctx;
};
